export default __webpack_public_path__ + "static/annotation-hn-light-mode-0ccda75cc44ddf89e66ad54386fade19.png";